import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import NotificationAPI from "apiConfig/NotificationAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  data: null,
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchNotification = createAsyncThunk(
  "notification/fetchNotification",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await NotificationAPI.post(
        "/abc-notification-service/v1/message",
        formData,
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    resetNotification: state => {
      state.data = null;
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchNotification.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(fetchNotification.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.status = Status.LOADED;
      })
      .addCase(fetchNotification.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetNotification } = NotificationSlice.actions;
export default NotificationSlice.reducer;
